import { render, staticRenderFns } from "./EmailMessageInv.vue?vue&type=template&id=b48216b4&scoped=true"
import script from "./EmailMessageInv.vue?vue&type=script&lang=js"
export * from "./EmailMessageInv.vue?vue&type=script&lang=js"
import style0 from "./EmailMessageInv.vue?vue&type=style&index=0&id=b48216b4&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48216b4",
  null
  
)

export default component.exports